var Paths;
(function (Paths) {
    Paths["main"] = "/";
    Paths["auth"] = "/auth";
    Paths["projects"] = "/projects";
    Paths["acts"] = "/acts";
    Paths["users"] = "/users";
})(Paths || (Paths = {}));
export { Paths };
